import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
    routes: [
        {
            path: '/',
            redirect: {name: 'error'}
        },
        {
            path: '/error',
            name: 'error',
            component: () => import('../views/error.vue')
        },
        {
            path: '/expoolRedirect/:exercisePoolId/:genre?/:Statu?',
            name: 'expoolRedirect',
            component: () => import('../views/expoolRedirect.vue'),
        },
        {
            path: '/ocr/expoolPicture/:exercisePoolId/:jing?/:Statu?',
            name: 'expoolPicture',
            component: () => import('../views/ocr/expoolPicture.vue'),
        },
        {
            path: '/ocr/expoolSinglePicture/:exercisePoolId/:index/:jing?/:Statu?',
            name: 'expoolSinglePicture',
            component: () => import('../views/ocr/expoolSinglePicture.vue'),
        },
        {
            path: '/ocr/expool/:exercisePoolId/:jing?/:Statu?',
            name: 'expool',
            component: () => import('../views/ocr/expool.vue'),
        },
        {
            path: '/expool/:exercisePoolId',
            name: 'expool',
            component: () => import('../views/expool/expool.vue'),
        },
        {
            path: '/questionManagement/questionUpload',
            name: 'questionupload',
            component: () => import('../views/questionManagement/questionUploadpage.vue')
        },
        //试卷管理页
        {
            path: '/questionManagement/paperedit/:exercisePoolId/:paperId?',
            name: 'paperEdit',
            component: () =>
                import ('../views/questionManagement/paperEdit.vue'),
        },
        {
            path: '/questionManagement/paperexedit/:exercisePoolId/:paperId/:exerciseId?',
            name: 'paperExerciseCreate',
            component: () =>
                import ('../views/questionManagement/paperExerciseCreate.vue'),
        }
    ]
})

// 全局路由守卫
router.beforeEach((to, from, next) => {
    function getCookie(name) {
        let arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        if (arr = document.cookie.match(reg))
            return decodeURIComponent(arr[2]);
        else
            return null;
    }

    // to: Route: 即将要进入的目标 路由对象
    // from: Route: 当前导航正要离开的路由
    // next: Function: 一定要调用该方法来 resolve 这个钩子。执行效果依赖 next 方法的调用参数。

    let isLogin = getCookie("localtoken") !== null;  // 是否登录

    // 未登录状态；当路由到nextRoute指定页时，跳转至login
    if (!isLogin && to.name !== 'error') {
        router.push({name: 'error'});
    }

    // 已登录状态；当路由到login时，跳转至home
    // if (to.name === 'login') {
    //     if (isLogin) {
    //         router.push('/');
    //     }
    // }

    next();
});

export default router;
